// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/minus.js';

import { paths } from '../generated/minus';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('minus', Original, paths);
